// Tudo o que o admin pode personalizar no INEP (Personalização). Cada texto tem uma chave;
// o valor salvo fica em inep_config/geral → textos[chave]. Sem valor salvo, vale o padrão.

export const GRUPOS_TEXTOS = [
  {
    grupo: 'Identidade',
    itens: [
      ['marca.sigla', 'Sigla da plataforma', 'INEP'],
      ['marca.nome', 'Nome por extenso', 'Instituto de Educação e Pesquisa'],
      ['topo.subtitulo', 'Subtítulo no topo da tela', 'Instituto de Educação e Pesquisa do Grupo Prontobaby'],
      ['topo.saudacao', 'Saudação (use {nome})', 'Olá, {nome} 👋'],
    ],
  },
  {
    grupo: 'Menu do aluno',
    itens: [
      ['menu.dash', 'Início', 'Início'],
      ['menu.quemsomos', 'Quem somos', 'Quem somos'],
      ['menu.cursos', 'Cursos', 'Cursos'],
      ['menu.continuar', 'Continuar aula', 'Continuar aula'],
      ['menu.avaliacoes', 'Avaliações', 'Avaliações'],
      ['menu.certs', 'Certificados', 'Certificados'],
      ['menu.chat', 'Chat', 'Chat com instrutores'],
      ['menu.jogo', 'Jogo educativo', 'Jogo educativo'],
      ['menu.conquistas', 'Conquistas', 'Conquistas'],
      ['menu.perfil', 'Meu perfil', 'Meu perfil'],
      ['menu.voltar', 'Voltar ao Quality', 'Voltar ao Quality'],
      ['menu.sair', 'Sair', 'Sair'],
    ],
  },
  {
    grupo: 'Tela inicial',
    itens: [
      ['dash.botaoCursos', 'Botão 1 do destaque', 'Ver meus cursos'],
      ['dash.botaoQuemSomos', 'Botão 2 do destaque', 'Conhecer o Grupo Prontobaby'],
      ['dash.kpi1', 'Indicador 1', 'Cursos em andamento'],
      ['dash.kpi2', 'Indicador 2', 'Progresso geral'],
      ['dash.kpi3', 'Indicador 3', 'Média das avaliações'],
      ['dash.kpi4', 'Indicador 4', 'Certificados disponíveis'],
      ['dash.continue', 'Título da lista de cursos', 'Continue de onde parou'],
      ['dash.verTodos', 'Link "ver todos"', 'Ver todos →'],
      ['dash.semCursos', 'Aviso sem cursos', 'Nenhum curso disponível para você ainda.'],
    ],
  },
  {
    grupo: 'Cursos e aulas',
    itens: [
      ['cursos.titulo', 'Título do catálogo', 'Cursos'],
      ['aula.texto', 'Texto abaixo do vídeo', 'Assista à videoaula e clique em "Marcar aula como concluída" para liberar a próxima.'],
      ['aula.atividade', 'Título do quadro da aula', 'Atividade da aula'],
      ['aula.botao', 'Botão de concluir aula', 'Marcar aula como concluída'],
      ['aula.concluida', 'Aula já concluída', '✓ Aula concluída'],
      ['aula.semVideo', 'Aula sem vídeo', 'Nenhum vídeo vinculado a esta aula'],
      ['continuar.vazio', 'Nada pendente', 'Nenhuma aula pendente — você concluiu todos os cursos disponíveis!'],
    ],
  },
  {
    grupo: 'Avaliações e certificados',
    itens: [
      ['aval.titulo', 'Título da página de avaliações', 'Minhas avaliações'],
      ['aval.aprovado', 'Mensagem de aprovação', 'Parabéns, você foi aprovado! Certificado liberado.'],
      ['aval.reprovado', 'Mensagem de reprovação (use {minimo})', 'Nota mínima é {minimo}. Revise o conteúdo e tente novamente.'],
      ['cert.instituicao', 'Certificado oficial — instituição', 'INEP – Instituto de Educação e Pesquisa do Prontobaby'],
      ['cert.cidade', 'Certificado oficial — cidade de emissão', 'Rio de Janeiro'],
      ['cert.titulo', 'Título da página de certificados', 'Meus certificados'],
      ['cert.cabecalho', 'Cabeçalho do certificado', '🎓 INEP — Certificado'],
      ['cert.frase', 'Frase do certificado', 'concluiu com êxito o curso'],
      ['cert.assinatura1Nome', 'Assinatura 1 — nome', 'Pdr. Dr. Mário Eduardo Viana'],
      ['cert.assinatura1Cargo', 'Assinatura 1 — cargo', 'Presidente Grupo Prontobaby'],
      ['cert.assinatura2Nome', 'Assinatura 2 — nome', 'Coordenação de Ensino'],
      ['cert.assinatura2Cargo', 'Assinatura 2 — cargo', 'INEP'],
    ],
  },
  {
    grupo: 'Chat, jogo e conquistas',
    itens: [
      ['chat.titulo', 'Título do chat', 'Chat com instrutores'],
      ['jogo.titulo', 'Nome do jogo', '🎮 Segurança em Ação'],
      ['jogo.subtitulo', 'Subtítulo do jogo', 'Aprenda segurança do trabalho jogando.'],
      ['jogo.dica', 'Dica do jogo', 'Dica: sinalize sempre pisos molhados — quedas são a principal causa de acidentes evitáveis.'],
      ['conq.titulo', 'Título das conquistas', 'Minhas conquistas'],
      ['conq.ranking', 'Título da classificação', 'Classificação geral'],
    ],
  },
  {
    grupo: 'Quem somos',
    itens: [
      ['qs.etiqueta', 'Etiqueta', 'O Grupo Prontobaby'],
      ['qs.titulo', 'Título', '65 anos cuidando da saúde infantil no Rio de Janeiro.'],
      ['qs.texto', 'Texto principal', 'Tudo começou em 1961, na Tijuca, com a fundação do Prontobaby — Hospital da Criança. Desde então o grupo cresceu até se tornar um dos maiores hospitais dedicados exclusivamente à pediatria do estado, somando hoje unidades entre hospital, pronto-atendimento, um instituto de especialidades e um serviço de home care. Essa mesma vocação para cuidar e formar pessoas é o que dá origem ao INEP — Instituto de Educação e Pesquisa: um espaço para que cada colaborador continue aprendendo com a qualidade que o grupo pratica todos os dias.', true],
      ['qs.numero1', 'Destaque 1 — número', '~400'],
      ['qs.numero1Texto', 'Destaque 1 — texto', 'leitos de internação clínica e cirúrgica entre as unidades do grupo'],
      ['qs.numero2', 'Destaque 2 — número', '4'],
      ['qs.numero2Texto', 'Destaque 2 — texto', 'unidades: hospital, emergência 24h, instituto de especialidades e home care'],
      ['qs.missao', 'Missão', 'Oferecer excelência, inovação e assistência integral em pediatria, com cuidado médico seguro e de alto padrão — e contribuir para a formação de novos especialistas.', true],
      ['qs.visao', 'Visão', 'Ser referência no atendimento pediátrico, ampliando alcance e impacto positivo na saúde infantil por meio de parcerias e crescimento constante.', true],
      ['qs.proposito', 'Propósito', 'Cuidar e ajudar a construir um futuro saudável para cada criança e adolescente atendido.', true],
      ['qs.citacao', 'Citação', 'Nossas mãos cuidando do seu bem maior.'],
      ['qs.citacaoAutor', 'Autor da citação', 'Dr. Mário Eduardo Viana — Presidente do Grupo Prontobaby'],
    ],
  },
];

export const TEXTOS_PADRAO = Object.fromEntries(GRUPOS_TEXTOS.flatMap(g => g.itens.map(([k, , v]) => [k, v])));

// Listas editáveis do "Quem somos"
export const VALORES_PADRAO = [
  { cor: '#0878b9', titulo: 'Cuidado', texto: 'Colocamos o bem-estar da criança e da família no centro de cada decisão.' },
  { cor: '#ff6a55', titulo: 'Excelência', texto: 'Buscamos o mais alto padrão técnico e humano em tudo que fazemos.' },
  { cor: '#1cbf82', titulo: 'Inovação', texto: 'Investimos continuamente em novas formas de cuidar e ensinar.' },
  { cor: '#ffae2b', titulo: 'Ética', texto: 'Agimos com transparência e responsabilidade em cada relação.' },
  { cor: '#8b6bff', titulo: 'Formação', texto: 'Acreditamos que ensinar bem é cuidar melhor.' },
];
export const TIMELINE_PADRAO = [
  { ano: '1961', texto: 'Fundação do Prontobaby, na Tijuca' },
  { ano: '1990s', texto: 'Expansão para novas unidades no Rio de Janeiro' },
  { ano: '2000s', texto: 'Criação do serviço de Home Care' },
  { ano: '2010s', texto: 'Abertura do Instituto de Especialidades' },
  { ano: 'Hoje', texto: 'Nasce o INEP — Instituto de Educação e Pesquisa' },
];
export const UNIDADES_PADRAO = [
  { nome: 'Hospital', etiqueta: 'Internação', cor1: '#075f94', cor2: '#22b8d9', texto: 'Pediatria clínica e cirúrgica' },
  { nome: 'Pronto Atend.', etiqueta: '24 horas', cor1: '#c23f2f', cor2: '#ff8a63', texto: 'Emergência pediátrica' },
  { nome: 'Instituto', etiqueta: 'Especialidades', cor1: '#0f8f61', cor2: '#3fdba0', texto: 'Consultas e exames' },
  { nome: 'Home Care', etiqueta: 'Domiciliar', cor1: '#5c3fd1', cor2: '#8b6bff', texto: 'Cuidado na casa do paciente' },
];

// Cores do tema (variáveis CSS de InepEnsino.css). "superficie": só vale no tema claro,
// para o modo escuro continuar legível.
export const CORES_TEMA = [
  { v: '--blue', rotulo: 'Cor principal (botões, links)', padrao: '#0878b9' },
  { v: '--blue-deep', rotulo: 'Cor principal escura', padrao: '#065f95' },
  { v: '--cyan', rotulo: 'Cor de apoio', padrao: '#22b8d9' },
  { v: '--navy', rotulo: 'Menu lateral (topo)', padrao: '#0a2540' },
  { v: '--navy2', rotulo: 'Menu lateral (base)', padrao: '#0f3760' },
  { v: '--coral', rotulo: 'Destaque coral', padrao: '#ff6a55' },
  { v: '--sun', rotulo: 'Destaque amarelo', padrao: '#ffae2b' },
  { v: '--mint', rotulo: 'Destaque verde', padrao: '#1cbf82' },
  { v: '--purple', rotulo: 'Destaque roxo', padrao: '#8b6bff' },
  { v: '--bg', rotulo: 'Fundo das telas', padrao: '#f2f6fb', superficie: true },
  { v: '--card', rotulo: 'Fundo dos cartões', padrao: '#ffffff', superficie: true },
  { v: '--ink', rotulo: 'Texto principal', padrao: '#10233b', superficie: true },
  { v: '--muted', rotulo: 'Texto secundário', padrao: '#5f7288', superficie: true },
  { v: '--line', rotulo: 'Bordas e divisórias', padrao: '#e4ecf3', superficie: true },
];

// Estilo (variáveis CSS) a aplicar no .inep-app a partir das cores salvas
export function estiloDoTema(cores, tema) {
  const estilo = {};
  CORES_TEMA.forEach(c => {
    const valor = cores?.[c.v];
    if (!valor || valor === c.padrao) return;
    if (c.superficie && tema === 'dark') return;
    estilo[c.v] = valor;
  });
  return estilo;
}
